import axios from 'axios'
import config from '@/config'
import store from '@/store'
import { Notice } from 'view-design'
// import { getExpires } from '@/libs/utils'
import { removeToken } from '@/libs/utils'
import i18n from '@/locale'

const LOGIN_REQUIRED_CODE = 40101
const PASSWORD_CHANGE_REQUIRED_CODE = 40102
let redirectingToLogin = false

function handlePasswordChangeRequired(data) {
	if (!data || data.code !== PASSWORD_CHANGE_REQUIRED_CODE) return false
	if (window.location.pathname !== '/force-password-change') {
		window.location.replace('/force-password-change')
	}
	return true
}

async function readResponseData(data) {
	if (typeof Blob === 'undefined' || !(data instanceof Blob) || !data.type.includes('application/json')) return data
	try {
		return JSON.parse(await new Promise((resolve, reject) => {
			const reader = new FileReader()
			reader.onload = () => resolve(reader.result)
			reader.onerror = () => reject(reader.error)
			reader.readAsText(data)
		}))
	} catch (_) {
		return data
	}
}

function handleLoginRequired(data) {
	if (!data || data.code !== LOGIN_REQUIRED_CODE) return false
	if (!redirectingToLogin) {
		redirectingToLogin = true
		removeToken()
		store.commit('setStoreToken', '')
		store.commit('setHasGetInfo', false)
		Notice.error({
			title: i18n.t('错误信息'),
			desc: data.message || '登录已失效，请重新登录'
		})
		if (window.location.pathname !== '/login') {
			window.location.replace('/login')
		} else {
			redirectingToLogin = false
		}
	}
	return true
}

const code = localStorage.getItem('code')
let baseURL = ''
if (code) {
	baseURL = config.baseUrl.pro[code].url
}
// const baseURL = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro[code]
// const baseURL = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : remote.getGlobal('shareAddress').url
const service = axios.create({
	baseURL: `${baseURL}api/v1/`,
	timeout: 120000,
	// baseURL: `${baseURL}api/v1/${localStorage.getItem('code')}`,
	headers: {
		// Accept: 'application/vnd.operationsystem.v1+json',
		// 'Content-Type': 'application/json'
	}
})

// request 拦截器
service.interceptors.request.use(
	(config) => {
		if (store.state.user.token) {
			config.headers['Authorization'] = `Bearer ${store.state.user.token}`
		}
		if (code) {
			config.headers['Platform-Code'] = code
		}
		config.params = {
			lang: i18n.locale,
			...config.params
		}
		return config
	},
	(error) => {
		return Promise.reject(error)
	}
)

// response 拦截器
service.interceptors.response.use(
	async (response) => {
		const data = await readResponseData(response.data)
		if (handleLoginRequired(data)) return Promise.reject(data)
		if (handlePasswordChangeRequired(data)) return Promise.reject(data)
		if (response.status > 400 && response.status < 500) {
			Notice.error({
				title: i18n.t('错误信息'),
				desc: response.data.error || response.data.message,
				duration: 8
			})
			return Promise.reject(response.data)
		}
		return response.data
	},
	async (error) => {
		const res = error.response
		const data = await readResponseData(res && res.data)
		if (handleLoginRequired(data)) return Promise.reject(error)
		if (handlePasswordChangeRequired(data)) return Promise.reject(error)
		Notice.error({
			title: i18n.t('错误信息'),
			desc: i18n.t((data && (data.message || data.error)) || error.message)
		})
		return Promise.reject(error)
	}
)

export default service
